import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import ModalTailwind from '../../components/ModalTailwind'; // Ajusta la ruta según tu estructura

export default function RegisterDoctor() {
  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    correo: '',
    celular: '',
    cedula: '',
    especialidad: '',
    cv: null,
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'cv') {
      setFormData({ ...formData, cv: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    try {
      const res = await fetch('https://www.fancyplus.digital/api/admin/solicitud', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await res.json();

      if (res.ok) {
        setFormData({
          nombre: '',
          apellidos: '',
          correo: '',
          celular: '',
          cedula: '',
          especialidad: '',
          cv: null,
        });
        setShowModal(true);
      } else {
        // Mostrar mensaje de error del backend
        setError(data.error || 'Error al enviar la solicitud');
      }
    } catch (err) {
      console.error(err);
      setError('Error en la red');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="relative">
      {/* Spinner de carga */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-40">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {/* Formulario */}
      <div className="max-w-4xl mx-auto p-8 bg-white rounded shadow-2xl mt-6">
        <h1 className="text-3xl font-bold text-center mb-2 text-blue-700">
          Trabaja atendiendo a nuestros clientes
        </h1>
        <p className="text-center mb-8 text-gray-600">
          Únete a nuestro equipo médico y ayuda a transformar la salud de miles de personas. Buscamos profesionales comprometidos, empáticos y apasionados por la tecnología.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} placeholder="Nombre" className="p-3 border rounded" required />
            <input type="text" name="apellidos" value={formData.apellidos} onChange={handleChange} placeholder="Apellidos" className="p-3 border rounded" required />
            <input type="email" name="correo" value={formData.correo} onChange={handleChange} placeholder="Correo electrónico" className="p-3 border rounded" required />
            <input type="tel" name="celular" value={formData.celular} onChange={handleChange} placeholder="Celular" className="p-3 border rounded" required />
            <input type="text" name="cedula" value={formData.cedula} onChange={handleChange} placeholder="Cédula profesional" className="p-3 border rounded" required />
            <input type="text" name="especialidad" value={formData.especialidad} onChange={handleChange} placeholder="Especialidad" className="p-3 border rounded" required />
          </div>

          <div>
            <label className="block mb-2 text-sm text-gray-700">Currículum (PDF)</label>
            <input type="file" name="cv" accept="application/pdf" onChange={handleChange} className="p-2 border rounded w-full" required />
          </div>
          
          {error && <p className="text-red-500 text-center">{error}</p>}

          <div className="text-center">
            <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition">
              Enviar solicitud
            </button>
          </div>
        </form>
      </div>

      {/* MODAL */}
      <ModalTailwind
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Solicitud enviada"
        onConfirm={() => setShowModal(false)}
      >
        <div className="flex items-center gap-3 mb-4 text-green-600">
          <FontAwesomeIcon icon={faCheckCircle} className="text-2xl" />
          <p className="text-sm sm:text-base">
            Tu solicitud fue enviada correctamente. Nos pondremos en contacto contigo por correo.
          </p>
        </div>

        <div className="flex justify-end gap-4">
          <Link to="/" className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">
            Ir a inicio
          </Link>
        </div>
      </ModalTailwind>
    </div>
  );
}
